























































import { PropType } from 'vue';
import { get } from 'vuex-pathify';

import { Choice, NewChoice } from '@/models/configurator/question';

import { Module } from '@/models/configurator/module';
import { cloneDeep } from 'lodash';

import draggable from '@/mixins/draggable';
import VueDraggable from 'vuedraggable';

import mixins from '@/utils/mixins';
import { omitDeep } from '@/utils/helpers';

export default mixins(draggable).extend({
  components: {
    VueDraggable
  },

  model: {
    prop: 'value',
    event: 'input'
  },

  props: {
    value: {
      type: Array as PropType<Choice[]>,
      default: () => []
    },

    itemRequired: {
      type: Boolean,
      default: false
    },

    moduleId: {
      type: [Number, String],
      default: null
    },

    computeQuantity: {
      type: Boolean
    },

    isNumeric: {
      type: Boolean
    }
  },

  data() {
    return {
      ruleSettings: [
        { text: 'Include If', value: 'include' },
        { text: 'Exclude If', value: 'exclude' }
      ],

      proxyChoices: [] as NewChoice[]
    };
  },

  computed: {
    modules: get<Module[]>('configuratorModule/modules'),
    questions: get<Module[]>('configuratorQuestion/questions'),

    computedQuantity: {
      get(): unknown {
        return this.computeQuantity;
      },
      set(val: any): void {
        this.$emit('update:computeQuantity', val);
      }
    },

    internalValue: {
      get(): unknown {
        return this.value; //v-model
      },
      set(val: any): void {
        this.$emit('input', val);
      }
    }
  },

  mounted() {
    this.proxyChoices = cloneDeep(this.internalValue);
  },

  methods: {
    updateChoiceOrder() {
      this.isDragging = false;

      const choices = this.proxyChoices.map((choice, index: number) => {
        choice.order = index + 1;
        return choice;
      });

      this.proxyChoices = choices;
      this.choiceUpdated();
    },

    sort() {
      this.proxyChoices = this.proxyChoices.sort((a, b) => a.order! - b.order!);
    },

    addChoice(copyOperation: boolean) {
      if (this.proxyChoices.length && copyOperation) {
        // Temporary hack to not modify rule/computation item 0 - Copied data should not include "id"
        const ruleClone = cloneDeep(this.proxyChoices[0].rule);
        const computationClone = cloneDeep(this.proxyChoices[0].computation);

        this.proxyChoices.push(
          new NewChoice({
            // Always copy rule and computation from first choice
            rule: omitDeep(ruleClone, ['id']),
            computation: omitDeep(computationClone, ['id']),
            order: this.proxyChoices.length ? this.proxyChoices.length + 1 : 1
          })
        );
      } else {
        this.proxyChoices.push(
          new NewChoice({
            order: this.proxyChoices.length ? this.proxyChoices.length + 1 : 1
          })
        );
      }
      // Update order to add order to each choice
      this.updateChoiceOrder();
      this.choiceUpdated();
    },

    removeChoice(index: number) {
      this.proxyChoices.splice(index, 1);
    },

    choiceUpdated() {
      this.internalValue = cloneDeep(this.proxyChoices);
    }
  }
});
